<script>
import { setLocale, translations } from '@/modules/i18n';

export default {
  name: 'LanguageDropdown',
  data() {
    return {
      translations
    };
  },
  methods: {
    // Compares a locale to the current locale
    isLocale(locale) {
      return this.$store.state.locale === locale;
    },

    // Sets the locale
    setLocale(locale) {
      setLocale(locale);
    }
  }
};
</script>

<template>
  <!-- Dropdown control -->
  <el-dropdown
    trigger="click"
    @command="setLocale"
  >
    <el-button>
      <i class="el-icon-fa-flag" />
      <i class="el-icon-fa-angle-down el-icon--right" />
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="{ code, name } in translations"
        :key="code"
        :class="{ 'checked': isLocale(code) }"
        :command="code"
      >
        {{ name }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

// No styles yet

</style>
